import { ReactNode, useEffect, useRef, useState } from 'react';
import { RiArrowDownSLine, RiArrowUpSLine, RiFilterLine } from 'react-icons/ri';
import { Dropdown } from '@Components/Dropdown';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { Placement, Size } from '@Components/designConstants';
import { useNotImplemented } from '../activity-feed-utils';
import {
  ALL_VALUE,
  CONFIDENCE_OPTIONS,
  RISK_TYPE_OPTIONS,
  SOURCE_OPTIONS
} from './activity-feed-filters-constants';
import { FilterSection } from './FilterSection';

// Collapsible "Advanced filters" section. Every dropdown is a shell today: enumerated options
// come from the type-level constants where they exist (SourceKind, ConfidenceBand, SignalTag);
// select fires useNotImplemented on change.
export const AdvancedFiltersSection = (): ReactNode => {
  const [expanded, setExpanded] = useState(false);
  const notImplemented = useNotImplemented();
  const bodyRef = useRef<HTMLDivElement>(null);

  // When the user expands the section, scroll the filter column so the freshly revealed body
  // sits fully in view. `block: 'end'` targets the bottom edge, which matters here because the
  // section lives at the bottom of the scroll container and would otherwise open off-screen.
  useEffect(() => {
    if (expanded) {
      bodyRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [expanded]);

  return (
    <div className='activity-feed-advanced'>
      <InteractiveDiv
        className='activity-feed-advanced-toggle'
        onClick={() => setExpanded(v => !v)}
      >
        <span className='activity-feed-advanced-toggle-label'>
          <RiFilterLine size={16} />
          Advanced filters
        </span>
        {expanded ? <RiArrowUpSLine size={20} /> : <RiArrowDownSLine size={20} />}
      </InteractiveDiv>
      {expanded && (
        <div className='activity-feed-advanced-body' ref={bodyRef}>
          <StubDropdownSection
            label='Source'
            allLabel='All sources'
            options={SOURCE_OPTIONS}
            onChange={notImplemented}
          />
          <StubDropdownSection
            label='AI Confidence'
            allLabel='All confidence levels'
            options={CONFIDENCE_OPTIONS}
            onChange={notImplemented}
          />
          <StubDropdownSection
            label='Risk Type'
            allLabel='All risk types'
            options={RISK_TYPE_OPTIONS}
            onChange={notImplemented}
          />
          <StubDropdownSection
            label='Created by'
            allLabel='All'
            options={[]}
            onChange={notImplemented}
          />
          <StubDropdownSection
            label='Created date'
            allLabel='All creation dates'
            options={[]}
            onChange={notImplemented}
          />
          <StubDropdownSection
            label='Last edited'
            allLabel='All edit dates'
            options={[]}
            onChange={notImplemented}
          />
        </div>
      )}
    </div>
  );
};

interface StubDropdownSectionProps {
  label: string;
  allLabel: string;
  options: { label: string; value: string }[];
  onChange: () => void;
}

const StubDropdownSection = ({
  label,
  allLabel,
  options,
  onChange
}: StubDropdownSectionProps): ReactNode => (
  <FilterSection label={label}>
    <Dropdown<string>
      size={Size.LG}
      overlayPlacement={Placement.RIGHT}
      options={[{ label: allLabel, value: ALL_VALUE }, ...options]}
      value={ALL_VALUE}
      onChange={onChange}
    />
  </FilterSection>
);
